import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-header d-flex flex-row align-items-center" }
const _hoisted_2 = { href: "/" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "flex-grow-1 d-flex justify-content-center" }

import { ref } from "vue";
import { useUserStore } from "@/store/user-store";
import { tenant } from "@/tenants/tenant";
import ShareProjectDialog from "@/components/Modals/ShareProjectDialog.vue";
import UserBadge from "@/components/Pages/UserBadge.vue";
import ProjectSurveyPicker from "@/components/Controls/ProjectSurveyPicker.vue";
import FeedbackButton from "@/components/Other/FeedbackButton.vue";
import CookieButton from "../Other/CookieButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  props: {
	showProject: {
		type: Boolean,
		default: true
	},
	showSurvey: {
		type: Boolean,
		default: true
	},
	showEditProjectButton: {
		type: Boolean,
		default: false
	},
	showShareButton: {
		type: Boolean,
		default: false
	}
},
  setup(__props) {

const prop = __props;

const shareProjectDialog = ref();
const userStore = useUserStore();



function showShareDialog() {
	shareProjectDialog.value.show();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, [
      _createElementVNode("img", {
        class: "logo",
        src: _unref(tenant).assets.headerLogoUrl,
        alt: _unref(tenant).displayName + ' logo'
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(ProjectSurveyPicker, {
        "show-project": prop.showProject,
        "show-survey": prop.showSurvey
      }, null, 8, ["show-project", "show-survey"])
    ]),
    (_unref(userStore).isLoggedIn() && prop.showShareButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn-link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showShareDialog()))
        }, " Share "))
      : _createCommentVNode("", true),
    _createVNode(UserBadge, { class: "badge" }),
    _createVNode(ShareProjectDialog, {
      class: "header-dialog",
      ref_key: "shareProjectDialog",
      ref: shareProjectDialog
    }, null, 512),
    (_unref(tenant).features.showFeedbackButton)
      ? (_openBlock(), _createBlock(FeedbackButton, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(CookieButton)
  ]))
}
}

})